import React from 'react';

import { ConfigureInventoryPanel } from './configure-inventory-panel';
import { EnableInventorySyncPanel } from './enable-inventory-sync-panel';
import { FeedbackPanel } from './feedback-panel';

/**
 * SetupGuidePanel component.
 * @param {object} props - The component props.
 * @param {boolean} props.isWarehouseConnected - Indicates if the warehouse is connected.
 * @param {boolean} props.isInventorySyncEnabled - Indicates if inventory sync is enabled.
 * @param {boolean} props.isAnyProductInInventory - Indicates if there is any product in inventory.
 * @param {boolean} props.isInventoryTrackingEnabled - Indicates if inventory tracking is enabled.
 * @returns {JSX.Element} The rendered component.
 */
export const SetupGuidePanel = ({ isWarehouseConnected, isInventorySyncEnabled, isAnyProductInInventory, isInventoryTrackingEnabled }) => {
  const render = () => {
    const isConfigurationDone = isInventoryTrackingEnabled && isWarehouseConnected && isAnyProductInInventory;

    if (!isConfigurationDone) {
      return (
        <ConfigureInventoryPanel
          isAnyProductInInventory={isAnyProductInInventory}
          isInventoryTrackingEnabled={isInventoryTrackingEnabled}
          isWarehouseConnected={isWarehouseConnected}
        />
      );
    }
    if (!isInventorySyncEnabled) {
      return <EnableInventorySyncPanel />;
    }
    return <FeedbackPanel />;
  };

  return render();
};
